import classNames from "../classNames";
import dialog from "../Modal/dialog";

const defaultProps = {
  title: "Success",
  icon: "bi bi-patch-check-fill",
  message: "Successfully Saved!",
};

function DialogSuccess({ title, icon, message, onClose }) {
  return (
    <div className="p-4">
      <div className="d-flex flex-column text-center gap-3">
        <div className="d-flex flex-column">
          <i
            className={classNames(icon, "text-success")}
            style={{ fontSize: "3rem" }}
          ></i>
          <h2 className="fw-bold m-0">{title}</h2>
        </div>

        <div className="d-flex flex-column">
          <p
            className="fs-6 m-0 text-muted fw-medium"
            style={{ lineHeight: "1.2rem" }}
          >
            {message}
          </p>
          <div className="mt-3">
            <button
              className="btn btn-primary w-50"
              style={{ backgroundColor: "#14213D" }}
              onClick={() => dialog.close()}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

DialogSuccess.defaultProps = defaultProps;
export default DialogSuccess;
